import { ChatMessage } from 'types/Chat'
import { Maybe } from 'types/Maybe'

interface ActiveGeneration {
  id: string
  chatId?: string
  assistantMessageId: string
  messages: ChatMessage[]
}

interface ThreadState {
  generation: Maybe<ActiveGeneration>
}

type ThreadEvent =
  | {
    type: 'generationStarted'
    generationId: string
    chatId?: string
    userMessage: ChatMessage
    assistantMessage: ChatMessage
  }
  | { type: 'chatCreated'; generationId: string; chatId: string }
  | { type: 'contentReceived'; generationId: string; text: string }
  | { type: 'generationEnded'; generationId: string }

const initialThreadState: ThreadState = { generation: null }

const chatThreadReducer = (state: ThreadState, event: ThreadEvent): ThreadState => {
  if (event.type === 'generationStarted') {
    if (state.generation) return state

    return {
      generation: {
        id: event.generationId,
        chatId: event.chatId,
        assistantMessageId: event.assistantMessage.id,
        messages: [event.userMessage, event.assistantMessage],
      },
    }
  }

  const { generation } = state
  if (!generation || generation.id !== event.generationId) return state

  switch (event.type) {
    case 'chatCreated':
      return { generation: { ...generation, chatId: event.chatId } }
    case 'contentReceived':
      return {
        generation: {
          ...generation,
          messages: generation.messages.map((message) => (
            message.id === generation.assistantMessageId
              ? { ...message, content: message.content + event.text }
              : message)),
        },
      }
    case 'generationEnded':
      return { generation: null }
    default:
      return state
  }
}

const selectPendingMessages = (state: ThreadState, chatId?: string) => (
  state.generation?.chatId === chatId ? state.generation?.messages : undefined
)

export type { ActiveGeneration, ThreadState, ThreadEvent }
export { chatThreadReducer, initialThreadState, selectPendingMessages }
